import { enterpriseBrand, hospitalBrand } from "../branding";
import type { ChatMessage, MessageThread } from "../types";

const safecheckAdminContact: Pick<
  MessageThread,
  "name" | "subtitle" | "avatar" | "avatarFallback" | "online"
> = {
  name: "SafeCheck RDC",
  subtitle: "Administration plateforme",
  avatar: "/icon.png",
  avatarFallback: "SC",
  online: true,
};

/** Fil unique — compte entreprise (CEEC) ↔ admin Safecheck */
export const enterpriseMessageThreads: MessageThread[] = [
  {
    id: "thread-safecheck-admin",
    ...safecheckAdminContact,
    lastMessage:
      "Votre demande de prise en charge a été transmise à l'équipe médicale.",
    lastMessageAt: "10:24",
    lastMessageDate: "26/06/2026",
    unreadCount: 2,
  },
];

export const enterpriseChatMessages: ChatMessage[] = [
  {
    id: "msg-1",
    threadId: "thread-safecheck-admin",
    sender: "them",
    content: "Bonjour, comment pouvons-nous vous aider aujourd'hui ?",
    time: "09:10",
    date: "26/06/2026",
  },
  {
    id: "msg-2",
    threadId: "thread-safecheck-admin",
    sender: "me",
    content:
      "Bonjour, nous souhaitons une prise en charge urgente pour un employé admis ce matin.",
    time: "09:15",
    date: "26/06/2026",
  },
  {
    id: "msg-3",
    threadId: "thread-safecheck-admin",
    sender: "them",
    content:
      "Merci pour votre message. Pouvez-vous préciser le matricule de l'employé concerné ?",
    time: "09:18",
    date: "26/06/2026",
  },
  {
    id: "msg-4",
    threadId: "thread-safecheck-admin",
    sender: "me",
    content: "Matricule 982 — MWEMA MUNGU, admission à Medecin de nuit.",
    time: "09:22",
    date: "26/06/2026",
  },
  {
    id: "msg-5",
    threadId: "thread-safecheck-admin",
    sender: "them",
    content:
      "Votre demande de prise en charge a été transmise à l'équipe médicale.",
    time: "10:24",
    date: "26/06/2026",
  },
];

/** Fil unique — compte prestataire (hôpital) ↔ admin Safecheck + auditeurs */
export const hospitalMessageThreads: MessageThread[] = [
  {
    id: "thread-safecheck-admin",
    ...safecheckAdminContact,
    lastMessage:
      "La prise en charge CEEC pour MWEMA MUNGU est confirmée. Vous pouvez poursuivre les soins.",
    lastMessageAt: "11:02",
    lastMessageDate: "26/06/2026",
    unreadCount: 1,
  },
  {
    id: "thread-hospital-auditor",
    name: "Audit Safecheck",
    subtitle: "Auditeur",
    avatarFallback: "AU",
    lastMessage:
      "Merci pour les pièces jointes. Nous finalisons le rapport d'audit cette semaine.",
    lastMessageAt: "15:20",
    lastMessageDate: "25/06/2026",
    unreadCount: 0,
    online: false,
  },
];

export const hospitalChatMessages: ChatMessage[] = [
  {
    id: "h-msg-1",
    threadId: "thread-safecheck-admin",
    sender: "them",
    content:
      "Bonjour Medecin de nuit, comment pouvons-nous vous accompagner aujourd'hui ?",
    time: "08:30",
    date: "26/06/2026",
  },
  {
    id: "h-msg-2",
    threadId: "thread-safecheck-admin",
    sender: "me",
    content:
      "Bonjour, nous avons reçu une admission pour MWEMA MUNGU (matricule CEEC 982). Pouvez-vous valider la prise en charge ?",
    time: "08:45",
    date: "26/06/2026",
  },
  {
    id: "h-msg-3",
    threadId: "thread-safecheck-admin",
    sender: "them",
    content:
      "Merci. Nous vérifions la couverture CEEC et revenons vers vous sous peu.",
    time: "09:05",
    date: "26/06/2026",
  },
  {
    id: "h-msg-4",
    threadId: "thread-safecheck-admin",
    sender: "me",
    content:
      "L'admission est programmée pour ce matin. Merci de confirmer dès que possible.",
    time: "09:40",
    date: "26/06/2026",
  },
  {
    id: "h-msg-5",
    threadId: "thread-safecheck-admin",
    sender: "them",
    content:
      "La prise en charge CEEC pour MWEMA MUNGU est confirmée. Vous pouvez poursuivre les soins.",
    time: "11:02",
    date: "26/06/2026",
  },
  {
    id: "h-msg-6",
    threadId: "thread-hospital-auditor",
    sender: "them",
    content:
      "Bonjour, nous auditons les factures de juin 2026. Pouvez-vous transmettre le détail des admissions MWEMA MUNGU ?",
    time: "14:05",
    date: "25/06/2026",
  },
  {
    id: "h-msg-7",
    threadId: "thread-hospital-auditor",
    sender: "me",
    content:
      "Bonjour, voici le récapitulatif des soins et la facture FAC-2026-0045 en pièce jointe.",
    time: "14:40",
    date: "25/06/2026",
  },
  {
    id: "h-msg-8",
    threadId: "thread-hospital-auditor",
    sender: "them",
    content:
      "Merci pour les pièces jointes. Nous finalisons le rapport d'audit cette semaine.",
    time: "15:20",
    date: "25/06/2026",
  },
];

/** Fils — compte auditeur ↔ prestataires de soins */
export const auditorMessageThreads: MessageThread[] = [
  {
    id: "thread-auditor-mdn",
    name: "Medecin de nuit",
    subtitle: "Prestataire de soins",
    avatar: hospitalBrand.profile,
    avatarFallback: "MD",
    lastMessage:
      "Bonjour, voici le récapitulatif des soins et la facture FAC-2026-0045 en pièce jointe.",
    lastMessageAt: "14:40",
    lastMessageDate: "25/06/2026",
    unreadCount: 1,
    online: true,
  },
];

export const auditorChatMessages: ChatMessage[] = [
  {
    id: "au-msg-1",
    threadId: "thread-auditor-mdn",
    sender: "me",
    content:
      "Bonjour, nous auditons les factures de juin 2026. Pouvez-vous transmettre le détail des admissions MWEMA MUNGU ?",
    time: "14:05",
    date: "25/06/2026",
  },
  {
    id: "au-msg-2",
    threadId: "thread-auditor-mdn",
    sender: "them",
    content:
      "Bonjour, voici le récapitulatif des soins et la facture FAC-2026-0045 en pièce jointe.",
    time: "14:40",
    date: "25/06/2026",
  },
  {
    id: "au-msg-3",
    threadId: "thread-auditor-mdn",
    sender: "me",
    content:
      "Merci pour les pièces jointes. Nous finalisons le rapport d'audit cette semaine.",
    time: "15:20",
    date: "25/06/2026",
  },
];

/** Boîte de réception admin — tous les comptes */
export const adminMessageThreads: MessageThread[] = [
  {
    id: "thread-admin-ceec",
    name: "CEEC",
    subtitle: "Entreprise",
    avatar: enterpriseBrand.profile,
    avatarFallback: "CE",
    lastMessage:
      "Votre demande de prise en charge a été transmise à l'équipe médicale.",
    lastMessageAt: "10:24",
    lastMessageDate: "26/06/2026",
    unreadCount: 0,
    online: false,
  },
  {
    id: "thread-admin-mdn",
    name: "Medecin de nuit",
    subtitle: "Prestataire de soins",
    avatar: hospitalBrand.profile,
    avatarFallback: "MD",
    lastMessage:
      "L'admission est programmée pour ce matin. Merci de confirmer dès que possible.",
    lastMessageAt: "09:40",
    lastMessageDate: "26/06/2026",
    unreadCount: 1,
    online: true,
  },
  {
    id: "thread-admin-auditor",
    name: "Audit Safecheck",
    subtitle: "Auditeur",
    avatarFallback: "AU",
    lastMessage:
      "Le rapport d'audit Q2 2026 est prêt pour validation par l'administration.",
    lastMessageAt: "16:45",
    lastMessageDate: "24/06/2026",
    unreadCount: 0,
    online: false,
  },
];

export const adminChatMessages: ChatMessage[] = [
  {
    id: "a-msg-1",
    threadId: "thread-admin-ceec",
    sender: "me",
    content: "Bonjour, comment pouvons-nous vous aider aujourd'hui ?",
    time: "09:10",
    date: "26/06/2026",
  },
  {
    id: "a-msg-2",
    threadId: "thread-admin-ceec",
    sender: "them",
    content:
      "Bonjour, nous souhaitons une prise en charge urgente pour un employé admis ce matin.",
    time: "09:15",
    date: "26/06/2026",
  },
  {
    id: "a-msg-3",
    threadId: "thread-admin-ceec",
    sender: "me",
    content:
      "Merci pour votre message. Pouvez-vous préciser le matricule de l'employé concerné ?",
    time: "09:18",
    date: "26/06/2026",
  },
  {
    id: "a-msg-4",
    threadId: "thread-admin-ceec",
    sender: "them",
    content: "Matricule 982 — MWEMA MUNGU, admission à Medecin de nuit.",
    time: "09:22",
    date: "26/06/2026",
  },
  {
    id: "a-msg-5",
    threadId: "thread-admin-ceec",
    sender: "me",
    content:
      "Votre demande de prise en charge a été transmise à l'équipe médicale.",
    time: "10:24",
    date: "26/06/2026",
  },
  {
    id: "a-msg-6",
    threadId: "thread-admin-mdn",
    sender: "me",
    content:
      "Bonjour Medecin de nuit, comment pouvons-nous vous accompagner aujourd'hui ?",
    time: "08:30",
    date: "26/06/2026",
  },
  {
    id: "a-msg-7",
    threadId: "thread-admin-mdn",
    sender: "them",
    content:
      "Bonjour, nous avons reçu une admission pour MWEMA MUNGU (matricule CEEC 982). Pouvez-vous valider la prise en charge ?",
    time: "08:45",
    date: "26/06/2026",
  },
  {
    id: "a-msg-8",
    threadId: "thread-admin-mdn",
    sender: "me",
    content:
      "Merci. Nous vérifions la couverture CEEC et revenons vers vous sous peu.",
    time: "09:05",
    date: "26/06/2026",
  },
  {
    id: "a-msg-9",
    threadId: "thread-admin-mdn",
    sender: "them",
    content:
      "L'admission est programmée pour ce matin. Merci de confirmer dès que possible.",
    time: "09:40",
    date: "26/06/2026",
  },
  {
    id: "a-msg-10",
    threadId: "thread-admin-mdn",
    sender: "me",
    content:
      "La prise en charge CEEC pour MWEMA MUNGU est confirmée. Vous pouvez poursuivre les soins.",
    time: "11:02",
    date: "26/06/2026",
  },
  {
    id: "a-msg-11",
    threadId: "thread-admin-auditor",
    sender: "them",
    content:
      "Bonjour, l'équipe d'audit a terminé la revue des factures Medecin de nuit pour juin 2026.",
    time: "16:10",
    date: "24/06/2026",
  },
  {
    id: "a-msg-12",
    threadId: "thread-admin-auditor",
    sender: "me",
    content: "Merci. Pouvez-vous partager le rapport consolidé ?",
    time: "16:25",
    date: "24/06/2026",
  },
  {
    id: "a-msg-13",
    threadId: "thread-admin-auditor",
    sender: "them",
    content:
      "Le rapport d'audit Q2 2026 est prêt pour validation par l'administration.",
    time: "16:45",
    date: "24/06/2026",
  },
];
